import FileAPI from "api/FileAPI";
import useFetchData from "hooks/useFetchData";

export default function useFilesList( params: FilesGETPaginatedParams ) {
    return useFetchData({
        APIMethod: FileAPI.getList,
        params: [ params ],
        clear_data_on_update: true
    })
}